export const FETCH_FEATUREDCARDS_REQUEST = "FETCH_FEATUREDCARDS_REQUEST";
export const FETCH_FEATUREDCARDS_SUCCESS = "FETCH_FEATUREDCARDS_SUCCESS";
export const FETCH_FEATUREDCARDS_FAILURE = "FETCH_FEATUREDCARDS_FAILURE";